document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.footer-block__heading').forEach(heading => {
        heading.addEventListener('click', () => {
            if (window.innerWidth < 750) {
                heading.closest('.footer-block').classList.toggle('active');
            }
        });
    })
});